<template>
  <layout-default-filters @open="$_onOpen" @apply="$_applyQueryString">
    <v-form ref="form">
      <!-- Filtro de Data (De / Até) -->
      <div class="linha">
        <core-date-picker-field
          clearable
          v-model="filters.createdFrom"
          label="De"
        />
      </div>

      <div class="linha">
        <core-date-picker-field
          clearable
          v-model="filters.createdBefore"
          label="Até"
          :rules="createdBeforeRules"
        />
      </div>

      <!-- Placa -->
      <div class="linha">
        <new-text-field
          background-color="white"
          class="pa-0"
          label="Placa"
          v-model="filters.placa"
          clearable
        />
      </div>

      <!-- Botão Limpar Filtros -->
      <div class="linha mt-3">
        <v-btn
          rounded
          outlined
          color="primary"
          block
          @click="$_limpar"
        >
          Limpar Filtros
        </v-btn>
      </div>
    </v-form>
  </layout-default-filters>
</template>

<script>
import { MANUTENCAO_QUERIES } from '@/constants/QUERY_FILTERS';
import { MANUTENCAO_STORAGE } from '@/constants/STORAGE';
import { getQueryValue, setQueryValue } from '@/services/query-string';

import LayoutDefaultFilters from '@/layouts/default/Filters.vue';
import CoreDatePickerField from '@/components/core/date-picker-field/Index.vue';
import NewTextField from '@/components/core/new-text-field/Index.vue';
import geraData from '@/utils/geradata';

export default {
  name: 'ViewsManutencaoFrotaFilters',

  components: {
    LayoutDefaultFilters,
    CoreDatePickerField,
    NewTextField,
  },

  data() {
    const hoje = geraData(new Date(), 'YYYY-MM-DD');
    const storageFrom = sessionStorage.getItem(MANUTENCAO_STORAGE.createdFrom);
    const storageBefore = sessionStorage.getItem(MANUTENCAO_STORAGE.createdBefore);
    const storagePlaca = sessionStorage.getItem(MANUTENCAO_STORAGE.placa);

    const from = getQueryValue(MANUTENCAO_QUERIES.createdFrom, storageFrom || hoje);
    const before = getQueryValue(MANUTENCAO_QUERIES.createdBefore, storageBefore || hoje);
    const placa = getQueryValue(MANUTENCAO_QUERIES.placa, storagePlaca || null);

    return {
      filters: {
        createdFrom: from,
        createdBefore: before,
        placa: (placa && placa !== 'null' && placa !== 'undefined') ? placa : null,
      },

      createdBeforeRules: [
        () => {
          if (!this.filters.createdFrom || !this.filters.createdBefore) return true;
          const fromDate = new Date(this.filters.createdFrom);
          const toDate = new Date(this.filters.createdBefore);
          return toDate >= fromDate || 'Data Final deve ser maior ou igual à Data Inicial';
        },
      ],
    };
  },

  methods: {
    $_applyQueryString() {
      setQueryValue(MANUTENCAO_QUERIES.createdFrom, this.filters.createdFrom || null);
      setQueryValue(MANUTENCAO_QUERIES.createdBefore, this.filters.createdBefore || null);
      setQueryValue(MANUTENCAO_QUERIES.placa, this.filters.placa || null);

      if (this.filters.createdFrom) {
        sessionStorage.setItem(MANUTENCAO_STORAGE.createdFrom, this.filters.createdFrom);
      } else {
        sessionStorage.removeItem(MANUTENCAO_STORAGE.createdFrom);
      }

      if (this.filters.createdBefore) {
        sessionStorage.setItem(MANUTENCAO_STORAGE.createdBefore, this.filters.createdBefore);
      } else {
        sessionStorage.removeItem(MANUTENCAO_STORAGE.createdBefore);
      }

      if (this.filters.placa) {
        sessionStorage.setItem(MANUTENCAO_STORAGE.placa, this.filters.placa);
      } else {
        sessionStorage.removeItem(MANUTENCAO_STORAGE.placa);
      }
    },

    $_syncFromRoute() {
      const hoje = geraData(new Date(), 'YYYY-MM-DD');
      const storageFrom = sessionStorage.getItem(MANUTENCAO_STORAGE.createdFrom);
      const storageBefore = sessionStorage.getItem(MANUTENCAO_STORAGE.createdBefore);
      const storagePlaca = sessionStorage.getItem(MANUTENCAO_STORAGE.placa);

      const from = getQueryValue(MANUTENCAO_QUERIES.createdFrom, storageFrom || hoje);
      const before = getQueryValue(MANUTENCAO_QUERIES.createdBefore, storageBefore || hoje);
      const placa = getQueryValue(MANUTENCAO_QUERIES.placa, storagePlaca || null);

      this.filters.createdFrom = from;
      this.filters.createdBefore = before;
      this.filters.placa = (placa && placa !== 'null' && placa !== 'undefined') ? placa : null;
    },

    $_onOpen() {
      this.$_syncFromRoute();
    },

    $_limpar() {
      const hoje = geraData(new Date(), 'YYYY-MM-DD');
      this.filters.createdFrom = hoje;
      this.filters.createdBefore = hoje;
      this.filters.placa = null;

      sessionStorage.setItem(MANUTENCAO_STORAGE.createdFrom, hoje);
      sessionStorage.setItem(MANUTENCAO_STORAGE.createdBefore, hoje);
      sessionStorage.removeItem(MANUTENCAO_STORAGE.placa);

      this.$_applyQueryString();
    },
  },

  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler() {
        this.$_syncFromRoute();
      },
    },

    filters: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          if (this.$refs.form && this.$refs.form.validate) {
            this.$refs.form.validate();
          }
        });
      },
    },
  },

  created() {
    const hoje = geraData(new Date(), 'YYYY-MM-DD');
    const storageFrom = sessionStorage.getItem(MANUTENCAO_STORAGE.createdFrom);
    const storageBefore = sessionStorage.getItem(MANUTENCAO_STORAGE.createdBefore);
    const storagePlaca = sessionStorage.getItem(MANUTENCAO_STORAGE.placa);

    const from = getQueryValue(MANUTENCAO_QUERIES.createdFrom, storageFrom || hoje);
    const before = getQueryValue(MANUTENCAO_QUERIES.createdBefore, storageBefore || hoje);
    const placa = getQueryValue(MANUTENCAO_QUERIES.placa, storagePlaca || null);

    this.filters.createdFrom = from;
    this.filters.createdBefore = before;
    this.filters.placa = (placa && placa !== 'null' && placa !== 'undefined') ? placa : null;

    setQueryValue(MANUTENCAO_QUERIES.createdFrom, this.filters.createdFrom);
    setQueryValue(MANUTENCAO_QUERIES.createdBefore, this.filters.createdBefore);
    if (this.filters.placa) {
      setQueryValue(MANUTENCAO_QUERIES.placa, this.filters.placa);
    }
  },
};
</script>

<style scoped>
.linha {
  margin-bottom: 8px;
}
</style>
